<template>
  <fragment>
    <AppBody
      :title="`Relatório de Vendas`"
      :subtitle="`Relatório de Vendas`"
      disableDivider
    >
      <ExpansionPanelFilters :title="$t('sales.affiliate_filter')">
        <v-form class="search-forms">
          <v-row>
            <v-col cols="12" md="3" sm="4">
              <DatePicker
                :label="'Dia'"
                :edit="diaFiltrado"
                @formatted-date="updateFilteredDay"
              />
            </v-col>
            <v-col class="d-flex justify-end">
              <BaseButton
                data-cy="filtrar"
                variant="filter"
                @click="applyFilter"
                :loading="$lojas_usuarios.usuarios_loading_button"
              >
                {{ $t("registrations.filter") }}
              </BaseButton>
            </v-col>
          </v-row>
        </v-form>
      </ExpansionPanelFilters>
      <v-row>
        <v-col cols="12">
          <v-card flat color="#e9e8ed" height="300px">
            <v-card
              class="dash-card rounded-lg"
              flat
              style="min-height: 80px; height: 100%; width: 100%"
              :class="{ 'mb-n5': !mdAndUp }"
            >
              <v-btn icon @click="refreshData" x-small class="refresh-button">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>

              <v-container class="py-4" style="min-width: 100%" fill-height>
                <v-row align="center" justify="center" class="total-sales">
                  <v-col class="text-center">
                    <v-card-title
                      class="fontDash-title card-title justify-center"
                    >
                      Total de Vendas
                    </v-card-title>
                    <v-progress-circular
                      :size="30"
                      :color="$config.dados.corinputs"
                      v-if="loading"
                      indeterminate
                      class="mt-4"
                    ></v-progress-circular>
                    <v-card-text v-else>
                      <p class="valor-total">
                        {{ formatCurrency(totalVendas + totalValueWEB) }}
                      </p>
                    </v-card-text>
                  </v-col>
                  <v-col class="text-center">
                    <p
                      style="color: rgba(0, 0, 0, 0.87)"
                      class="fontDash-title card-title justify-center"
                    >
                      Quantidade
                    </p>
                    <v-progress-circular
                      :size="30"
                      :color="$config.dados.corinputs"
                      v-if="loading"
                      indeterminate
                      class="mt-6"
                    ></v-progress-circular>
                    <v-card-text v-else class="valor-total">
                      <p class="valor-total">
                        {{ totalQuantidade + totalQuantidadeWEB }}
                      </p>
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card flat color="#e9e8ed" :height="mdAndUp ? '300px' : '580px'">
            <v-card
              class="dash-card rounded-lg"
              flat
              style="min-height: 100%; height: 100%; width: 100%"
              :class="{ 'mb-n5': !mdAndUp }"
            >
              <v-btn icon @click="refreshData" x-small class="refresh-button">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>

              <v-container class="py-4" style="min-width: 100%" fill-height>
                <v-row align="center" justify="center">
                  <v-col class="text-center">
                    <v-card-title
                      class="fontDash-title card-title justify-center"
                    >
                      Ingressos Inteira Vendidos
                    </v-card-title>
                    <v-progress-circular
                      :size="30"
                      :color="$config.dados.corinputs"
                      v-if="loading"
                      indeterminate
                      class="mt-4"
                    ></v-progress-circular>
                    <v-card-text v-else class="valor-total">
                      <p class="valor-total">
                        {{ formatCurrency(totalInteira) }}
                      </p>
                    </v-card-text>
                    <v-card-text>
                      <v-col
                        cols="12"
                        class="fontDash-title card-title justify-center"
                      >
                        <p
                          class="fontDash-title card-title justify-center"
                          style="
                            color: rgba(0, 0, 0, 0.87);
                            padding-bottom: 16px;
                          "
                        >
                          Quantidade
                        </p>
                        <v-progress-circular
                          :size="30"
                          :color="$config.dados.corinputs"
                          v-if="loading"
                          indeterminate
                          class="mt-4"
                        ></v-progress-circular>
                        <p v-else class="valor-total">
                          {{ this.quantidadeInteira }}
                        </p>
                      </v-col>
                    </v-card-text>
                  </v-col>
                  <v-col class="text-center">
                    <v-card-title
                      class="fontDash-title card-title justify-center"
                    >
                      Ingressos Meia Vendidos
                    </v-card-title>
                    <v-progress-circular
                      :size="30"
                      :color="$config.dados.corinputs"
                      v-if="loading"
                      indeterminate
                      class="mt-4"
                    ></v-progress-circular>
                    <v-card-text v-else class="valor-total">
                      <p class="valor-total">
                        {{ formatCurrency(totalMeia) }}
                      </p>
                    </v-card-text>
                    <v-card-text>
                      <v-col
                        cols="12"
                        class="fontDash-title card-title justify-center"
                      >
                        <p
                          class="fontDash-title card-title justify-center"
                          style="
                            color: rgba(0, 0, 0, 0.87);
                            padding-bottom: 16px;
                          "
                        >
                          Quantidade
                        </p>
                        <v-progress-circular
                          :size="30"
                          :color="$config.dados.corinputs"
                          v-if="loading"
                          indeterminate
                          class="mt-4"
                        ></v-progress-circular>
                        <p v-else class="valor-total">
                          {{ this.quantidadeMeia }}
                        </p>
                      </v-col>
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col no-gutters cols="12" md="6">
          <v-card flat color="#e9e8ed" :height="'300px'">
            <v-card
              class="dash-card rounded-lg"
              flat
              style="min-height: 100%; height: 100%; width: 100%"
              :class="{ 'mb-n5': !mdAndUp }"
            >
              <v-btn icon @click="refreshData" x-small class="refresh-button">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>

              <!-- Ajuste no layout -->
              <v-container class="py-4" fill-height>
                <v-row align="center" justify="center">
                  <v-col class="text-center">
                    <v-card-title
                      class="fontDash-title card-title justify-center"
                    >
                      Total de Vendas WEB
                    </v-card-title>
                    <v-progress-circular
                      :size="30"
                      :color="$config.dados.corinputs"
                      v-if="loading"
                      indeterminate
                      class="mt-4"
                    ></v-progress-circular>
                    <v-card-text v-else class="valor-total">
                      <p class="valor-total">
                        {{ formatCurrency(totalWEB) }}
                      </p>
                    </v-card-text>
                    <v-card-text>
                      <v-col
                        cols="12"
                        class="fontDash-title card-title justify-center"
                      >
                        <p
                          class="fontDash-title card-title justify-center"
                          style="
                            color: rgba(0, 0, 0, 0.87);
                            padding-bottom: 16px;
                          "
                        >
                          Quantidade
                        </p>
                        <v-progress-circular
                          :size="30"
                          :color="$config.dados.corinputs"
                          v-if="loading"
                          indeterminate
                          class="mt-4"
                        ></v-progress-circular>
                        <p v-else class="valor-total">
                          {{ this.quantidadeWEB }}
                        </p>
                      </v-col>
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <v-card flat color="#e9e8ed" :height="'300px'">
            <v-card
              class="dash-card rounded-lg"
              flat
              style="min-height: 100%; height: 100%; width: 100%"
              :class="{ 'mb-n5': !mdAndUp }"
            >
              <v-btn icon @click="refreshData" x-small class="refresh-button">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>

              <!-- Ajuste no layout -->
              <v-container class="py-4" fill-height>
                <v-row align="center" justify="center">
                  <v-col class="text-center">
                    <v-card-title
                      class="fontDash-title card-title justify-center"
                    >
                      Total de Vendas Bilheteria
                    </v-card-title>
                    <v-progress-circular
                      :size="30"
                      :color="$config.dados.corinputs"
                      v-if="loading"
                      indeterminate
                      class="mt-4"
                    ></v-progress-circular>
                    <v-card-text v-else>
                      <p class="valor-total">
                        {{ formatCurrency(+totalBilheteriaWE + +totalWEBPOS) }}
                      </p>
                    </v-card-text>
                    <v-card-text>
                      <v-col
                        cols="12"
                        class="fontDash-title card-title justify-center"
                      >
                        <p
                          class="fontDash-title card-title justify-center"
                          style="
                            color: rgba(0, 0, 0, 0.87);
                            padding-bottom: 16px;
                          "
                        >
                          Quantidade
                        </p>
                        <v-progress-circular
                          :size="30"
                          :color="$config.dados.corinputs"
                          v-if="loading"
                          indeterminate
                          class="mt-4"
                        ></v-progress-circular>
                        <p v-else class="valor-total">
                          {{
                            +this.quantidadeBilheteriaWE +
                            +this.quantidadeWEBPOS
                          }}
                        </p>
                      </v-col>
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <v-card flat color="#e9e8ed" :height="'300px'">
            <v-card
              class="dash-card rounded-lg"
              flat
              style="min-height: 100%; height: 100%; width: 100%"
              :class="{ 'mb-n5': !mdAndUp }"
            >
              <v-btn icon @click="refreshData" x-small class="refresh-button">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>

              <!-- Ajuste no layout -->
              <v-container class="py-4" fill-height>
                <v-row align="center" justify="center">
                  <v-col class="text-center">
                    <v-card-title
                      class="fontDash-title card-title justify-center"
                    >
                      Total de Vendas Totens
                    </v-card-title>
                    <v-progress-circular
                      :size="30"
                      :color="$config.dados.corinputs"
                      v-if="loading"
                      indeterminate
                      class="mt-4"
                    ></v-progress-circular>
                    <v-card-text v-else class="valor-total">
                      <p class="valor-total">
                        {{ formatCurrency(totalTotenWE) }}
                      </p>
                    </v-card-text>
                    <v-card-text>
                      <v-col
                        cols="12"
                        class="fontDash-title card-title justify-center"
                      >
                        <p
                          class="fontDash-title card-title justify-center"
                          style="
                            color: rgba(0, 0, 0, 0.87);
                            padding-bottom: 16px;
                          "
                        >
                          Quantidade
                        </p>
                        <v-progress-circular
                          :size="30"
                          :color="$config.dados.corinputs"
                          v-if="loading"
                          indeterminate
                          class="mt-4"
                        ></v-progress-circular>
                        <p v-else class="valor-total">
                          {{ this.quantidadeTotenWE }}
                        </p>
                      </v-col>
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <v-card flat color="#e9e8ed" :height="'300px'">
            <v-card
              class="dash-card rounded-lg"
              flat
              style="min-height: 100%; height: 100%; width: 100%"
              :class="{ 'mb-n5': !mdAndUp }"
            >
              <v-btn icon @click="refreshData" x-small class="refresh-button">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>

              <!-- Ajuste no layout -->
              <v-container class="py-4" fill-height>
                <v-row align="center" justify="center">
                  <v-col class="text-center">
                    <v-card-title
                      class="fontDash-title card-title justify-center"
                    >
                      Total de Vendas Agências
                    </v-card-title>
                    <v-progress-circular
                      :size="30"
                      :color="$config.dados.corinputs"
                      v-if="loading"
                      indeterminate
                      class="mt-4"
                    ></v-progress-circular>
                    <v-card-text v-else class="valor-total">
                      <p class="valor-total">
                        {{ formatCurrency(totalAgenciaWE) }}
                      </p>
                    </v-card-text>
                    <v-card-text>
                      <v-col
                        cols="12"
                        class="fontDash-title card-title justify-center"
                      >
                        <p
                          class="fontDash-title card-title justify-center"
                          style="
                            color: rgba(0, 0, 0, 0.87);
                            padding-bottom: 16px;
                          "
                        >
                          Quantidade
                        </p>
                        <v-progress-circular
                          :size="30"
                          :color="$config.dados.corinputs"
                          v-if="loading"
                          indeterminate
                          class="mt-4"
                        ></v-progress-circular>
                        <p v-else class="valor-total">
                          {{ this.quantidadeAgenciaWE }}
                        </p>
                      </v-col>
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <v-card flat color="#e9e8ed" :height="'300px'">
            <v-card
              class="dash-card rounded-lg"
              flat
              style="min-height: 100%; height: 100%; width: 100%"
              :class="{ 'mb-n5': !mdAndUp }"
            >
              <v-btn icon @click="refreshData" x-small class="refresh-button">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>

              <!-- Ajuste no layout -->
              <v-container class="py-4" fill-height>
                <v-row align="center" justify="center">
                  <v-col class="text-center">
                    <v-card-title
                      class="fontDash-title card-title justify-center"
                    >
                      Total de Cortesias
                    </v-card-title>
                    <v-progress-circular
                      :size="30"
                      :color="$config.dados.corinputs"
                      v-if="loading"
                      indeterminate
                      class="mt-4"
                    ></v-progress-circular>
                    <v-card-text v-else class="valor-total">
                      {{
                        +this.totalCortesiaWE + +this.quantidadeWEBWHITELABEL
                      }}
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-show="false">
        <v-col cols="12" md="6">
          <v-card flat color="#e9e8ed" height="250px">
            <v-card
              class="dash-card rounded-lg"
              flat
              style="min-height: 80px; height: 100%; width: 100%"
              :class="{ 'mb-n5': !mdAndUp }"
            >
              <v-btn
                icon
                @click="refreshData"
                x-small
                class="refresh-button"
                v-if="mdAndUp"
              >
                <v-icon>mdi-refresh</v-icon>
              </v-btn>

              <!-- Ajuste no layout -->
              <v-container class="py-4" fill-height>
                <v-row align="center" justify="center">
                  <v-col class="text-center">
                    <v-card-title
                      class="fontDash-title card-title justify-center"
                    >
                      Total de acesso no evento
                    </v-card-title>
                    <v-progress-circular
                      :size="60"
                      :color="$config.dados.corinputs"
                      v-if="loading"
                      indeterminate
                      class="mt-n2"
                    ></v-progress-circular>
                    <v-card-text v-else class="valor-total">
                      {{ this.totalEntradasEvento }}
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <v-card flat color="#e9e8ed" height="100%">
            <v-card
              class="dash-card rounded-lg"
              flat
              style="min-height: 80px; height: 100%; width: 100%"
              :class="{ 'mb-n5': !mdAndUp }"
            >
              <v-btn
                icon
                @click="refreshData"
                x-small
                class="refresh-button"
                v-if="mdAndUp"
              >
                <v-icon>mdi-refresh</v-icon>
              </v-btn>

              <!-- Ajuste no layout -->
              <v-container class="py-4" fill-height>
                <v-row align="center" justify="center">
                  <v-col class="text-center">
                    <v-card-title
                      class="fontDash-title card-title justify-center"
                    >
                      Público Atual
                    </v-card-title>
                    <v-progress-circular
                      :size="60"
                      :color="$config.dados.corinputs"
                      v-if="loading"
                      indeterminate
                      class="mt-n2"
                    ></v-progress-circular>
                    <v-card-text v-else class="valor-total">
                      {{ this.publicoAtual }}
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-card>
        </v-col>
      </v-row>
    </AppBody>
  </fragment>
</template>

<script>
import AppBody from "@/layouts/components/AppBody.vue";
import displayHelpers from "@/mixins/breakpoints.mixins";
import { formatCurrency } from "@/utils";
import { mapGetters } from "vuex";
import ExpansionPanelFilters from "../../../components/forms/ExpansionPanelFilters.vue";
import mixins from "../../../mixins";
import BaseButton from "../../../components/forms/BaseButton.vue";
import DatePicker from "../../../components/forms/DatePicker.vue";

const { formRules } = mixins;
export default {
  name: "ConsumerDailyAnalytical",
  components: {
    AppBody,
    ExpansionPanelFilters,
    BaseButton,
    DatePicker,
  },
  mixins: [displayHelpers, formRules],
  data() {
    return {
      loading: true,
      totalBilheteriaWE: 0,
      quantidadeBilheteriaWE: 0,
      totalAgenciaWE: 0,
      quantidadeAgenciaWE: 0,
      quantidadeTotenWE: 0,
      totalTotenWE: 0,
      totalEntradasEvento: 0,
      publicoAtual: 0,
      totalCortesiaWE: 0,
      totalVendas: 0,
      totalQuantidade: 0,
      totalWEB: 0,
      quantidadeWEB: 0,
      quantidadeWEBPOS: 0,
      totalWEBPOS: 0,
      quantidadeWEBWHITELABEL: 0,
      totalInteira: 0,
      totalMeia: 0,
      quantidadeInteira: 0,
      quantidadeMeia: 0,
      diaFiltrado: "12/10/2024",
      formatCurrency,
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    updateFilteredDay(formattedDate) {
      this.diaFiltrado = formattedDate;
    },
    async refreshData() {
      this.loading = true;
      const dataECOMMERCE = await this.$loja_gerenciar.getVendasDiarias(
        this.diaFiltrado
      );
      const dataWE = await this.$loja_gerenciar.getVendasDiariasWE(
        this.diaFiltrado
      );
      //const accessDataWE = await this.$loja_gerenciar.getAcessosWE(
      //this.diaFiltrado
      //);

      this.totalBilheteriaWE =
        dataWE.result?.tipos.find(result => result.descricao === "bilheteria")
          ?.valor_total ?? 0;

      this.quantidadeBilheteriaWE =
        dataWE.result?.tipos.find(result => result.descricao === "bilheteria")
          ?.quantidade ?? 0;

      this.totalAgenciaWE =
        dataWE.result?.tipos.find(result => result.descricao === "agencia")
          ?.valor_total ?? 0;

      this.quantidadeAgenciaWE =
        dataWE.result?.tipos.find(result => result.descricao === "agencia")
          ?.quantidade ?? 0;

      this.totalTotenWE =
        dataWE.result?.tipos.find(result => result.descricao === "toten")
          ?.valor_total ?? 0;

      this.quantidadeTotenWE =
        dataWE.result?.tipos.find(result => result.descricao === "toten")
          ?.quantidade ?? 0;
      this.totalCortesiaWE =
        dataWE.result?.tipos.find(result => result.descricao === "cortesia")
          ?.quantidade ?? 0;

      //this.totalEntradasEvento = accessDataWE.result.entradas_evento;
      //this.publicoAtual =
      //  accessDataWE.result.entradas_hoje - accessDataWE.result.saidas_hoje;

      this.totalVendas = dataWE?.result?.totalizador ?? 0;
      this.totalQuantidade = dataWE?.result?.totalizador_quantidade ?? 0;

      this.totalWEB = dataECOMMERCE?.ELEVENTICKETS?.valor_total ?? 0;

      this.totalValueWEB =
        (dataECOMMERCE?.ELEVENTICKETS?.valor_total ?? 0) +
        (dataECOMMERCE?.POS?.valor_total ?? 0) +
        (dataECOMMERCE?.WHITELABEL?.valor_total ?? 0);

      this.totalQuantidadeWEB =
        (dataECOMMERCE?.ELEVENTICKETS?.qtd ?? 0) +
        (dataECOMMERCE?.POS?.qtd ?? 0) +
        (dataECOMMERCE?.WHITELABEL?.qtd ?? 0);

      this.quantidadeWEBPOS = dataECOMMERCE?.POS?.qtd ?? 0;
      this.totalWEBPOS = dataECOMMERCE?.POS?.valor_total ?? 0;
      this.quantidadeWEB = dataECOMMERCE?.ELEVENTICKETS?.qtd ?? 0;
      this.quantidadeWEBWHITELABEL = dataECOMMERCE?.WHITELABEL?.qtd ?? 0;

      const ingressosInteira = dataECOMMERCE?.ingressos?.filter(ingresso =>
        ingresso.dsc_produto.toLowerCase().includes("inteira")
      );

      const somaIngressosEcommerceInteira =
        ingressosInteira?.reduce(
          (total, ingresso) => total + (ingresso.valor_total ?? 0),
          0
        ) ?? 0;

      const quantidadeIngressosEcommerceInteira =
        ingressosInteira?.reduce(
          (total, ingresso) => total + (ingresso.qtd_itens_pagos ?? 0),
          0
        ) ?? 0;

      const ingressosMeia = dataECOMMERCE?.ingressos?.filter(ingresso =>
        ingresso.dsc_produto.toLowerCase().includes("meia")
      );

      const somaIngressosEcommerceMeia =
        ingressosMeia?.reduce(
          (total, ingresso) => total + (ingresso.valor_total ?? 0),
          0
        ) ?? 0;

      const quantidadeIngressosEcommerceMeia =
        ingressosMeia?.reduce(
          (total, ingresso) => total + (ingresso.qtd_itens_pagos ?? 0),
          0
        ) ?? 0;

      const somaWEInteira =
        dataWE.result?.tipos_ingressos?.find(
          result => result.tipo === "inteira"
        )?.valor_total ?? 0;

      const somaWEMeia =
        dataWE.result?.tipos_ingressos?.find(result => result.tipo === "meia")
          ?.valor_total ?? 0;

      const quantidadeWEInteira =
        dataWE.result?.tipos_ingressos?.find(
          result => result.tipo === "inteira"
        )?.quantidade ?? 0;

      const quantidadeWEMeia =
        dataWE.result?.tipos_ingressos?.find(result => result.tipo === "meia")
          ?.quantidade ?? 0;

      this.totalInteira = +somaIngressosEcommerceInteira + +somaWEInteira;

      this.totalMeia = +somaWEMeia + +somaIngressosEcommerceMeia;

      this.quantidadeInteira =
        +quantidadeWEInteira + +quantidadeIngressosEcommerceInteira;

      this.quantidadeMeia =
        +quantidadeWEMeia + +quantidadeIngressosEcommerceMeia;

      this.loading = false;
    },
    applyFilter() {
      if (this.diaFiltrado.length < 10) return;
      this.refreshData();
    },
  },
  async mounted() {
    this.refreshData();
  },
};
</script>

<style scoped>
.card-title {
  font-size: 20px !important;
  font-weight: normal;
  line-height: 1.75rem;
  letter-spacing: 0.009375em !important;
  font-family: "Archivo", sans-serif !important;
  margin-bottom: 8px;
}

.valor-total {
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 2rem;
  color: rgb(87, 44, 136);
}

.refresh-button {
  width: 100%;
  justify-content: end;
  padding-right: 8px;
}

@media (max-width: 800px) {
  .total-sales {
    display: flex;
    flex-direction: column;
  }
}
</style>
